<template>
  <b-modal
      modal-class="footer-dialog"
      data-test-path="inquiry-attachment"
      id="bv-modal-select-language"
      :title="$tr('PrintoutLanguageDialog.selectLanguage','Select the Language in Which You Want to Print Document')"
      @close="onHide"
      data-backdrop="static" data-keyboard="false"
      size="xl"
      ref="modal"
  >
    <b-container class="px-0 mx-0" fluid="true">
      <b-container>
        <b-form-group :label="$tr('selectLanguage','Select Language')">
          <b-form-select v-model="language" :options="formattedLanguageOptions"></b-form-select>
        </b-form-group>

        <b-form-group class="mt-3">
          <b-form-checkbox v-model="shouldRemember">{{ $tr("rememberThisChoice", "Remember this choice") }}
          </b-form-checkbox>
        </b-form-group>
        <div v-if="error" class="mt-3 text-danger text-left">
          {{ $tr("PrintoutLanguageDialog.notPickLanguage", "You did not pick a language! Language is necessary!") }}
        </div>
      </b-container>
    </b-container>
    <b-container v-if="(horizontalTemplate !== printout && horizontalTemplateEnabled)" class="px-3 mx-0" fluid="true">
      <b-row>
        <b-col class="mt-3">
          <b-form-checkbox v-model="selected">
            <span>
              {{ $tr("PrintoutLanguageDialog.horizontalTemplate", "Horizontal template") }}
            </span>
          </b-form-checkbox>
        </b-col>
      </b-row>
    </b-container>
    <template #modal-footer="{close}" class="p-0">
      <FooterNavbar data-test-path="attachment-dialog-footer" class="w-100">
        <CloseButton :read-only="readOnly" @close="onHide"></CloseButton>
        <FooterButton
            :disabled="!language"
            type="Save"
            @save="onOk"
        >
        </FooterButton>
      </FooterNavbar>
    </template>
  </b-modal>
</template>

<script>
import FooterNavbar from "@/components/navbar/FooterNavbar";
import FooterButton from "@/components/navbar/FooterButton";
import CloseButton from "@/components/navbar/CloseButton";
import {PrintoutLanguageDialogResult} from "@/components/dialogs/results/PrintoutLanguageDialogResult";
import PrintoutManager from "@/PrintoutManager";
import Rpc from "@/Rpc";

export default {
  name: "PrintoutLanguageDialog",
  components: {FooterButton, FooterNavbar, CloseButton},

  data: () => {
    return {
      horizontalTemplateEnabled: true,
      resolve: null,
      result: null,
      readOnly: true,
      shouldRemember: false,
      language: AppTranslations.selectedLang ?? 'en',
      languageOptions: {},
      form: {},
      printout: null,
      selectionLocal: [],
      error: false,
      selected: false,
      horizontalTemplate: "",
    }
  },

  computed: {
    formattedLanguageOptions() {
      return Object.keys(this.languageOptions).map(key => ({
        value: key,
        text: this.languageOptions[key]
      }));
    }
  },

  methods: {
    async onOk() {
      if (this.language) {
        if (this.resolve != null) {
          this.result = new PrintoutLanguageDialogResult();
          this.result.shouldRemember = this.shouldRemember;
          this.result.language = this.language;
          this.result.form = this.form;
          this.result.printout = this.printout;
          this.result.selectionLocal = this.selectionLocal;
          this.resolve(this.result);
          this.resolve = null;
        }
        this.$refs.modal.hide();
        await PrintoutManager._executePrintout(this.form, this.selected ? this.horizontalTemplate : this.printout, this.selectionLocal, this.language);
        this.error = false;
      } else {
        this.error = true;
      }
    },

    async onHide(ev) {
      if (this.resolve != null) {
        this.result = new PrintoutLanguageDialogResult();
        this.result.shouldRemember = this.shouldRemember;
        this.result.language = this.language;
        this.result.form = this.form
        this.result.printout = this.printout;
        this.result.selectionLocal = this.selectionLocal;
        this.resolve(this.result);
        this.resolve = null;
      }
      this.$refs.modal.hide();
    },

    reset() {
      this.result = null;
      this.resolve = null;
      this.readOnly = true;
    },

    edit() {
      this.readOnly = false;
    },

    async prepareListLang() {
      this.languageOptions = await Rpc.AppTranslations.languageInSelectedInterfaceLanguage();
      if (Object.keys(this.languageOptions).length === 1) {
        this.language = Object.keys(this.languageOptions)[0];
        this.onOk();
      }
    }
  }
}
</script>
